import React, { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,  
  Card,
  CardContent,
  Select,
  MenuItem,
} from "@mui/material";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { LANG_VERSIONS } from "../constants";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


const IdeDesc = ({description,example,constraints,solutions,submissions,questionList,title,handleQuestionChange,selectedQuestion,submitStatus}) => {



const leftButtonList = submitStatus
  ? ["Description", "Solutions", "Current Submission", "Past Submissions"]
  : ["Description", "Solutions", "Past Submissions"];



const [leftActiveButton, setLeftActiveButton] = useState("Description");
const languages = Object.entries(LANG_VERSIONS);
const [solutionLanguage,setSolutionLanguage]=useState('python');
console.log("example\n",example);


const handleButtonClick = (buttonName) => {
  setLeftActiveButton(buttonName);
};

const handleSolutionChange = (event) => {
  setSolutionLanguage(event.target.value);
};






  return (
    <Box
      sx={{  
        borderRadius: "5px",
        height:'100%'        
      }}
    >
      <Box
        sx={{
          backgroundColor: "#36343B",
          borderTopLeftRadius: "5px",
          borderTopRightRadius: "5px",
          height: "55px",
          display: "flex",
          alignItems: "center",
          padding: "10px",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {leftButtonList.map((buttonName) => (
            <Button
              key={buttonName}
              variant="text"
              onClick={() => handleButtonClick(buttonName)}
              sx={{
                zIndex: 20,
                color: "#181719",
                height: "45px",                
                borderBottom:
                  leftActiveButton === buttonName ? "2px solid white" : "none",
                marginRight: "10px",
                borderRadius: "5px 5px 0 0",
                "&:hover": {
                  backgroundColor: "#372D43",
                },
              }}
            >
              <Typography sx={{ color: "white" }}>{buttonName}</Typography>
            </Button>
          ))}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          backgroundColor: "#181719"
        }}
      >
        {leftActiveButton === "Description" && (
          <Select
            value={selectedQuestion}
            onChange={handleQuestionChange}
            displayEmpty
            sx={{
              color: "white",
              height: "35px",
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
              "& .MuiSelect-icon": {
                color: "white",
              },
              "&:hover": { backgroundColor: "#372D43", color: "white" },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&:focus": {
                outline: "none",
              },
              "&.Mui-selected": {
                backgroundColor: "#372D43",
              },
              "&.Mui-selected:hover": {
                backgroundColor: "#372D43",
              },
              borderRadius: "5px ",
            }}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return (
                  <Typography sx={{ color: "white" }}>
                    Select a question
                  </Typography>
                );
              }
              return selected;
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  "& .MuiList-root": {
                    padding: "3px",
                  },
                },
              },
            }}
          >
            {questionList.map((question, index) => (
              <MenuItem
                key={index}
                value={question.title}
                sx={{
                  backgroundColor: "transparent !important",
                  "&.Mui-selected": {
                    backgroundColor: "transparent !important",
                  },
                  "&:hover": {
                    backgroundColor: "grey !important",
                  },
                  borderRadius: "5px",
                  marginTop: "3px",
                  marginBottom: "3px;",
                }}
              >
                {question.title}
              </MenuItem>
            ))}
          </Select>
        )}
      </Box>
      {leftActiveButton === "Description" && (
        <Card
          sx={{
            backgroundColor: "#181719",
            color: "white",
            padding: 2,
            overflowY: "auto",
            maxHeight: "90vh",
            height:'100%',
            borderRadius:"0"
          }}
        >
          <CardContent>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
              {title}
            </Typography>
            <Typography variant="body1" paragraph>
              {description}
            </Typography>
            
            <Box sx={{ marginBottom: 2 }}>
              {example.split('\n\n').map((ex, index) => {
                const lines = ex.split('\n');
                const exampleTitle = lines[0].trim(); // e.g., "Example 1:"
                const exampleContent = lines.slice(1).map(line => line.trim()).join('\n'); // Rest of the lines
                return (
                  <Box key={index} sx={{ marginBottom: 1 }}>
                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                      {exampleTitle}
                    </Typography>
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        whiteSpace: 'pre-line', 
                        marginLeft: 2 // Indents the content under the example title
                      }}
                    >
                      {exampleContent}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
            
            
            
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Constraints:
            </Typography>
            <Box component="ul" sx={{ paddingLeft: 2 }}>
              {constraints.map((constraint, index) => (
                <Typography key={index} component="li" variant="body1">
                  {constraint}
                </Typography>
              ))}
            </Box>
          </CardContent>
        </Card>
      )}
      {leftActiveButton === "Solutions" && (
        <Card
          sx={{
            backgroundColor: "#181719",
            color: "white",
            padding: 2,
            overflowY: "auto",
            maxHeight: "100vh",
            height:'100%',
            borderRadius:'0'
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
                Solution:
              </Typography> */}
              <Box sx={{ marginLeft: "auto" }}>
                {/* <Select
                        value={solutionLanguage}
                        onChange={handleSolutionChange}
                        variant="outlined"
                        displayEmpty
                        sx={{
                          color: 'white',
                          borderRadius: '4px',
                          height: '35px',
                          '.MuiOutlinedInput-notchedOutline': { border: 0 },
                          '& .MuiSelect-icon': {
                            color: 'white',
                          },
                          '&:hover': { backgroundColor: '#372D43' },
                          '&:focus': {
                            outline: 'none',
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                          },
                          '& .MuiSelect-select': {
                            display: 'flex',
                            alignItems: 'center',
                          },
                          '&.Mui-selected': {
                            backgroundColor: '#372D43',
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: '#372D43',
                          },
                        }}
                        IconComponent={ArrowDropDownIcon}
                        renderValue={(selected) => {
                          if (!selected) {
                            return <Typography sx={{ color: 'white' }}>Select Language</Typography>;
                          }
                          return selected;
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              '& .MuiList-root': {
                                padding: '3px',
                              },
                            },
                          },
                        }}
                      >
                        {languages.map(([lang, version]) => (
                          <MenuItem
                            key={lang}
                            value={lang}
                            sx={{
                              backgroundColor: 'transparent',
                              '&.Mui-selected': {
                                backgroundColor: 'transparent !important',
                              },
                              '&:hover': {
                                backgroundColor: 'grey !important',
                              },
                              borderRadius: '4px',
                              marginTop: '3px',
                              marginBottom: '3px'
                            }}
                          >
                            {lang}
                          </MenuItem>
                        ))}
                      </Select> */}
              </Box>
            </Box>

            {solutions
              .filter(
                (solution) => solution.language.toLowerCase() === solutionLanguage
              )
              .map((solution, index) => (
                <Box key={index} marginTop={5} sx={{ borderBottom: 1, paddingBottom: 3 }}>
                  <Typography variant="h5" paragraph marginTop="10px" sx={{ fontWeight: 'bold' }}>
                    {solution.language}
                  </Typography>
                  <SyntaxHighlighter language="python" style={oneDark}>
                    {solution.solution}
                  </SyntaxHighlighter>
                  
                  <Typography variant="h6" paragraph marginTop={2} sx={{ fontWeight: 'bold' }}>
                    Explanation:
                  </Typography>
                  
                  {/* Format the explanation with proper paragraphs and bullet points */}
                  <Box sx={{ padding: 1 }}>
                    {solution.explanation.split('. ').map((sentence, i) => {
                      // Check if this appears to be a list item or a heading
                      if (sentence.trim().startsWith('Initialize') || 
                          sentence.trim().startsWith('Create') ||
                          sentence.trim().startsWith('Start') ||
                          sentence.trim().startsWith('Inside') ||
                          sentence.trim().startsWith('Check')) {
                        return (
                          <Box key={i} sx={{ display: 'flex', marginBottom: 1 }}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold', marginRight: 1 }}>
                              •
                            </Typography>
                            <Typography variant="body1">
                              {sentence.trim()}.
                            </Typography>
                          </Box>
                        );
                      } else if (sentence.includes('Intuition')) {
                        return (
                          <Typography key={i} variant="subtitle1" sx={{ fontWeight: 'bold', marginTop: 2, marginBottom: 1 }}>
                            {sentence.trim()}.
                          </Typography>
                        );
                      } else {
                        return (
                          <Typography key={i} variant="body1" paragraph>
                            {sentence.trim()}.
                          </Typography>
                        );
                      }
                    })}
                  </Box>
                </Box>
              ))}

            {solutions.filter(
              (solution) => solution.language.toLowerCase() === solutionLanguage
            ).length === 0 && (
              <Typography variant="body1" paragraph>
                No solution available for the selected language.
              </Typography>
            )}
          </CardContent>
        </Card>
      )}

      {leftActiveButton === "Past Submissions" && (
        <Card
          sx={{
            backgroundColor: "#181719",
            color: "white",
            padding: 2,
            overflowY: "auto",
            maxHeight: "100vh",
            height:'100%',
            borderRadius:'0'
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            ></Box>
            {/* <Typography variant="h4" gutterBottom>
              Past Attempts:
            </Typography> */}
            {submissions.length > 0 ? (
              submissions.map((submission, index) => (
                <Box key={index} marginTop={5} sx={{ borderBottom: 1 }}>
                  <Typography variant="h5" paragraph marginTop="10px" sx={{ fontWeight: 'bold' }}>
                    Submission:
                  </Typography>
                  <Typography variant="h7" paragraph>
                    Language: {submission.language}
                  </Typography>
                  <Box sx={{ width: "100%" }}>
                    <SyntaxHighlighter language="python" style={oneDark}>
                      {submission.content}
                    </SyntaxHighlighter>
                  </Box>

                  <Typography variant="h5" paragraph>
                    Results:
                  </Typography>
                  <Typography variant="body1" paragraph>
                    {submission.results}
                  </Typography>
                </Box>
              ))
            ) : (
              <Typography variant="body1" paragraph>
                No existing submissions for this question.
              </Typography>
            )}
          </CardContent>
        </Card>
      )}
      {leftActiveButton === "Current Submission" && (
        <Card
          sx={{
            backgroundColor: "#181719",
            color: "white",
            padding: 2,
            overflowY: "auto",
            maxHeight: "100vh",            
            height:'100%',
            borderRadius:'0'
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            ></Box>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
              Submission:
            </Typography>
            <Box marginTop={5} sx={{ borderBottom: 1 }}>
              <Typography variant="h5" paragraph marginTop="10px">
                Code:
              </Typography>
              <Typography variant="h7" paragraph>
                Language: {submissions[0].language}
              </Typography>
              <Box sx={{ width: "100%" }}>
                <SyntaxHighlighter language="python" style={oneDark}>
                  {submissions[0].content}
                </SyntaxHighlighter>
              </Box>

              <Typography variant="h5" paragraph>
                Results:
              </Typography>
              <Typography variant="body1" paragraph>
                {submissions[0].results}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default IdeDesc;
